import {call, put, select, takeLatest} from 'redux-saga/effects'
import {
  create,
  deleteSchedulerSetting,
  filterDataChange,
  filterSchedulerDataChange,
  filterSchedulerOrderDataChange,
  getAll,
  getAllLogs,
  getSchedulerOrderList,
  setError,
  setList,
  setSchedulerLogList,
  setSchedulerOrderList,
  setSuccess,
  setVerifyFolderResult,
  trySchedulerSetting,
  updateSchedulerSettingStatus,
  verifyFolder,
} from './SchedulerRedux'
import {ResponseGenerator} from '../../../shared/models/ResponseGenerator'
import {
  createSchedulerSetting,
  deleteSchedulerSettingById,
  getAllSchedulerOrderList,
  getAllUserSchedulerLogs,
  getAllUserSchedulerSetting,
  trySchedulerSettingFolder,
  updateSchedulerSettingStatusById,
  verifyDriveFolder,
} from './SchedulerApi'
import {HTTP_CODE} from '../../../shared/constants'
import {history} from '../../../../setup/history'

import {SchedulerFilterModel} from '../models/SchedulerListFilterModel'
import {SchedulerLogFilterModel} from '../models/SchedulerLogListFilterModel'
import {SchedulerOrderListFilterModel} from '../models/SchedulerOrderListFilterModel'
import { getCurrentIntl } from '../../../shared/utils/i18nUtils'
export default function* saga() {
  yield takeLatest(
    [getSchedulerOrderList.type, filterSchedulerOrderDataChange.type],
    function* getAllSchedulerOrder(action: ReturnType<typeof getSchedulerOrderList>) {
      try {
        const id = action.payload.schedulerId
        const filterData: SchedulerOrderListFilterModel = yield select(
          (state) => state.scheduler.schedulerOrderFilter
        )
        const response: ResponseGenerator = yield call(
          getAllSchedulerOrderList,
          id.toString(),
          filterData
        )

        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setSchedulerOrderList(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    deleteSchedulerSetting.type,
    function* handleDeleteSchedulerSetting(action: ReturnType<typeof deleteSchedulerSetting>) {
      try {
        const response: ResponseGenerator = yield call(deleteSchedulerSettingById, action.payload)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        const currentIntl = getCurrentIntl()
        yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.DELETED'})))
        yield put(getAll())
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    updateSchedulerSettingStatus.type,
    function* handleUpdateSchedulerSettingStatus(
      action: ReturnType<typeof updateSchedulerSettingStatus>
    ) {
      try {
        const response: ResponseGenerator = yield call(
          updateSchedulerSettingStatusById,
          action.payload.id,
          action.payload.status
        )
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        const currentIntl = getCurrentIntl()
        yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.UPDATED'})))
        yield put(getAll())
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    trySchedulerSetting.type,
    function* handleTryScheduler(action: ReturnType<typeof trySchedulerSetting>) {
      try {
        const {folderName, schedulerId} = action.payload
        const response: ResponseGenerator = yield call(
          trySchedulerSettingFolder,
          folderName,
          schedulerId
        )
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        const currentIntl = getCurrentIntl()
        yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.EXECUTED'})))
        //redirect to scheduler log page
        history.push('/schedulers/logs')
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    create.type,
    function* handleCreateSchedulerSetting(action: ReturnType<typeof create>) {
      try {
        const response: ResponseGenerator = yield call(createSchedulerSetting, action.payload)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        const currentIntl = getCurrentIntl()
        yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.CREATED'})))
        history.push('/schedulers')
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    [getAll.type, filterDataChange.type],
    function* getAllSchedulerSetting(action: ReturnType<typeof getAll>) {
      try {
        const filterData: SchedulerFilterModel = yield select((state) => state.scheduler.filter)
        const response: ResponseGenerator = yield call(getAllUserSchedulerSetting, filterData)

        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setList(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )

  yield takeLatest(
    [getAllLogs.type, filterSchedulerDataChange.type],
    function* getAllSchedulerLogs(action: ReturnType<typeof filterSchedulerDataChange>) {
      try {
        const filterData: SchedulerLogFilterModel = yield select(
          (state) => state.scheduler.schedulerLogsFilter
        )
        const response: ResponseGenerator = yield call(getAllUserSchedulerLogs, filterData)

        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setSchedulerLogList(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )

  yield takeLatest(
    verifyFolder.type,
    function* checkingUserFolderPermission(action: ReturnType<typeof verifyFolder>) {
      try {
        const folderId = action.payload
        const response: ResponseGenerator = yield call(verifyDriveFolder, folderId)
        if (response && response.status === HTTP_CODE.SUCCESS) {
          yield put(setVerifyFolderResult(response.data))
        }
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
}
